var _rect, _g, _g2, _g3, _g4, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneMockup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "root",
    width: 466,
    height: 959,
    viewBox: "0 0 466 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 460,
    height: 958.746,
    rx: 56,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8735_36233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.113281,
    y: 350.775,
    width: 2.8853,
    height: 72.7778,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8735_36233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.113281,
    y: 258.441,
    width: 2.8853,
    height: 72.7778,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8735_36233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.113281,
    y: 187.547,
    width: 2.8853,
    height: 38.5663,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8735_36233)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.8853,
    height: 115.233,
    transform: "matrix(-1 0 0 1 465.885 308.316)",
    fill: "#D9D9D9"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.83496,
    y: 5.97656,
    width: 448.459,
    height: 946.578,
    rx: 52,
    fill: "#F3F2F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1387,
    y: 16.7178,
    width: 427.849,
    height: 925.095,
    rx: 42,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8735_36233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.114258 352.421C0.114258 351.511 0.852426 350.772 1.763 350.772H2.99956V423.729H1.763C0.852426 423.729 0.114258 422.991 0.114258 422.081V352.421Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8735_36233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.114258 260.09C0.114258 259.18 0.852426 258.441 1.763 258.441H2.99956V331.398H1.763C0.852426 331.398 0.114258 330.66 0.114258 329.75V260.09Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8735_36233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.114258 189.195C0.114258 188.284 0.852426 187.546 1.763 187.546H2.99956V226.291H1.763C0.852426 226.291 0.114258 225.553 0.114258 224.643V189.195Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8735_36233"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.885 309.965C465.885 309.055 465.147 308.316 464.236 308.316H462.999V423.729H464.236C465.147 423.729 465.885 422.99 465.885 422.08V309.965Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMockup);
export default __webpack_public_path__ + "static/media/phone-mockup.be998259095630fac74f26c20cdd6965.svg";
export { ForwardRef as ReactComponent };